import React from 'react';

import { cn } from 'components/lib/utils';

interface IInfoNoteProps {
  children: React.ReactNode;
  className?: string;
}

export const InfoNote: React.FC<IInfoNoteProps> = ({ children, className }) => {
  return (
    <div className={cn('flex items-start gap-2 text-p-xs text-base-mutedForeground', className)}>
      <span className="inline-block w-2 h-2 rounded-full bg-indigo-500 mt-1 flex-shrink-0" />
      <span>{children}</span>
    </div>
  );
};

